import React from "react";
import Style from "../../style/eventlandingright.module.scss";

interface EventProps {
  relatedEvents: any[];
  currentEventId: number;
}

const EventLandingRight: React.FC<EventProps> = ({
  relatedEvents,
  currentEventId,
}) => {
  return (
    <div className={Style.rightContainer}>
      <div className={Style.banner}>
        <h3>🔥 Trending This Week</h3>
        <p>Explore upcoming sessions you might love based on your interest.</p>
        <a href="/all-event" className={Style.exploreBtn}>
          Explore All Events
        </a>
      </div>
      <h2>Related Events</h2>
      {relatedEvents
        .filter((event) => event.id !== currentEventId)
        .slice(0, 20)
        .map((event, index) => (
          <div key={event.id} className={Style.relatedCard}>
            <h4>{event.venue.name}</h4>
            <p>{event.venue.city}</p>
            <p>
              {event.start_date} - {event.end_date}
            </p>
            <small>{event.categories.join(", ")}</small>
          </div>
        ))}
    </div>
  );
};

export default EventLandingRight;
